export enum TabType {
  Radio = 'radio',
  AudioDedication = 'dedicacesaudio',
  Alarm = 'reveil',
  Html = 'html',
  Dedication = 'dedicaces',
  LiveFeed = 'livefeed',
  Rss = 'rss',
  Website = 'site',
  Podcast = 'podcasts',
  SongHistory = 'ckoi',
}

export interface TabModel {
  idonglets: number;
  headerColor: string;
  headerTextColor: string;
  icon: string;
  faIcon: string;
  titre: string;
  type: TabType;
}

export type DedicationTabModel = TabModel; // No specific model
export type LiveFeedTabModel = TabModel; // No specific model
export type SongHistoryTabModel = TabModel; // No specific model

export interface WebsiteTabModel extends TabModel {
  urlSite: string;
}

export interface RssTabModel extends TabModel {
  urlFlux: string;
  limit: string;
}

export interface HtmlTabModel extends TabModel {
  codeHTML: string;
  backgroundColor: string;
}

export interface AlarmClockTabModel extends TabModel {
  backgroundColor?: string;
  backgroundreveilappfield?: string;
  backgroundreveiliphone5appfield?: string;
  backgroundreveiliphoneXappfield?: string;
}

export interface AudioDedicationTabModel extends TabModel {
  idradio: number;
  foregroundColor: string;
  backgroundColor: string;
  welcomeMessage: string;
  endMessage: string;
}

export type FontFamily =
  | 'Comfortaa'
  | 'DancingScript'
  | 'EBGaramond'
  | 'Fedroka'
  | 'JosefinSans'
  | 'Oswald'
  | 'PlayfairDisplay'
  | 'Poppins'
  | 'Quicksand'
  | 'Raleway'
  | 'Roboto'
  | 'RobotoMono'
  | 'Solway';

export type TextAlign = 'left' | 'right' | 'center' | 'justify';

export interface RadioTabModel extends TabModel {
  achatOption: 'YES' | 'NO';
  alwaysDefaultCover: 'YES' | 'NO';
  artistLabelColor: string;
  autoPlay: string;
  backgroundColor: string;
  backgroundColorSecondary: string;
  backgroundappfield: string;
  backgroundiphone5appfield: string;
  backgroundiphoneXappfield: string;
  backgroundOption: 'cover' | 'image' | 'color';
  backgroundType: 'solid' | 'gradient' | 'bicolor';
  blurredBackground: 'YES' | 'NO';
  bottomColor: string;
  boutonPlay: string;
  boutonPlayTheme2: string;
  buttonStyle: 'primary' | 'secondary';
  callOption: 'YES' | 'NO';
  coverBorderColor: string;
  coverType: 'square' | 'rounded-square' | 'circle';
  divRadius: number;
  divShadow: number;
  divWithMargin: 'YES' | 'NO';
  emailAddress: string;
  emailOption: 'YES' | 'NO';
  facebookAPIKey: string;
  fondTitrage: 'YES' | 'NO';
  fontFamily: FontFamily;
  fontSize: number;
  gradientDirection: 'bottom' | 'bottom-right' | 'right' | 'bottom-left';
  iconStyle: 'solid' | 'regular';
  itunesId: string;
  logoappfield: string;
  mainColor: string;
  nomColor: string;
  partage: 'YES' | 'NO';
  phoneNumber: string;
  pochette: string;
  pochettedefaut: string;
  showBlurredCover: 'YES' | 'NO';
  showHeaderLogo: 'YES' | 'NO';
  showCoverBorder: 'YES' | 'NO';
  showMenuLogo: 'YES' | 'NO';
  sleeptimerOption: 'YES' | 'NO';
  sliderColor: string;
  smsNumber: string;
  smsOption: 'YES' | 'NO';
  statusBar: string;
  textAlign: TextAlign;
  theme: string;
  theme3_artistLabelColor: string;
  theme3_backgroundColorBottom: string;
  theme3_backgroundColorTop: string;
  theme3_backgroundType: string;
  theme3_bottomIconColor: string;
  theme3_coverType: string;
  theme3_header: string;
  theme3_headerBackgroundColor: string;
  theme3_headerForegroundColor: string;
  theme3_playerButtonColor: string;
  theme3_sliderColor: string;
  theme3_titleLabelColor: string;
  titleLabelColor: string;
  voteOption: 'YES' | 'NO';
  flux: StreamModel[];
}

export interface StreamModel {
  id: number;
  logoappfield: string;
  nomFlux: string;
  typeTitrage: string;
  urlFlux: string;
  urlFluxBD: string;
  urlFluxHD: string;
  ckoiConfiguration: SongHistoryConfig;
}

export interface PodcastTabModel extends TabModel {
  podcastsRssList: string[];
  backgroundColor: string;
  forceBackgroundColor: boolean;
}

export interface SongHistoryConfig {
  active: boolean;
  apiUrl?: string;
  searchApiUrl?: string;
  dateOptionAvailable: boolean;
  timeOptionAvailable: boolean;
  searchOptionAvailable: boolean;
}
